import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { EndPoints } from "../../../../endPoints/endPoints";
import { IContarctAircraft, IContarctAircraftAdd } from "./IContactAircraft";
import { IContractWork } from "../contractWorks/IContractWork";

export const contractAircraftsApi = createApi({
  reducerPath: "contract-aircrafts",
  baseQuery: fetchBaseQuery({
    baseUrl: EndPoints.CONTRACT_AIRCRAFTS,
  }),
  tagTypes: ["contract-aircrafts", "contract-aircraft"],
  endpoints: (builder) => ({
    getAllContractAircrafts: builder.query<IContarctAircraft[], number>({
      query(contract_id) {
        return {
          url: `/contract/${contract_id}`,
          method: "GET",
          credentials: "include",
        };
      },
      providesTags: ["contract-aircrafts"],
    }),
    addContractAircraft: builder.mutation<any, IContarctAircraftAdd>({
      query(data) {
        const { cost, ...rest } = data;
        const costInCents = Math.floor(cost * 100);

        return {
          url: "",
          method: "POST",
          credentials: "include",
          body: { cost: costInCents, ...rest },
        };
      },
      invalidatesTags: ["contract-aircrafts"],
    }),
    editContractAircraft: builder.mutation<IContractWork, IContractWork>({
      query({ id, ...data }) {
        const { cost, ...rest } = data;
        const costInCents = Math.floor(cost * 100);
        return {
          url: `/${id}`,
          method: "PUT",
          credentials: "include",
          body: { cost: costInCents, ...rest },
        };
      },
      invalidatesTags: ["contract-aircraft", "contract-aircrafts"],
    }),
    deleteContractAircraft: builder.mutation<string, number>({
      query(id) {
        return {
          url: `/${id}`,
          method: "DELETE",
          credentials: "include",
        };
      },
      invalidatesTags: ["contract-aircrafts"],
    }),
  }),
});

export const {
  useGetAllContractAircraftsQuery,
  useAddContractAircraftMutation,
  useDeleteContractAircraftMutation,
  useEditContractAircraftMutation,
} = contractAircraftsApi;
